export const normalizeContent = data => {
  return Object.values(data).map((value, idx) => {
    const key = Object.keys(data)[idx]

    if(!Array.isArray(value)) return value

    switch(key) {
      case 'chapters':
        return normalizeChapters(data)

      case 'pages':
        return normalizePages(value)

      case 'navigation':
        return normalizeNavigation(value)

      case 'quizes':
        return normalizeQuizes(data)

      default:
        return normalize(value, key)
    }
  }).reduce((acc, item, idx) => {
    acc[Object.keys(data)[idx]] = item
    return acc
  }, {})
}

export const normalizeNavigation = data => {
  const nav = data.map(item => ({
    ...item,
    chapterId: item.chapterId ?  `chapter-${item.chapterId}` : null,
    pageId: item.pageId ? `page-${item.pageId}` : null,
    quizId: item.quizId ? `quiz-${item.quizId}` : null,
    prefix: item.id,
  }))

  return {
    list: normalize(nav, 'navigation'),
    progress: {},
  }
}

export const normalizeQuizes = data => {
  const quizes = []
  const questions = []
  const answers = []

  data.quizes.forEach(quiz => {
    quizes.push({
      ...quiz,
      prefix: quiz.id,
      questions: (quiz.questions && quiz.questions.map(item => `question-${quiz.id}-${item.id}`)) || [],
    })

    quiz.questions.forEach(question => {
      questions.push({
        ...question,
        id: `question-${quiz.id}-${question.id}`,
        quizId: `quiz-${quiz.id}`,
        prefix: question.id,
        answers: (question.answers && question.answers.map(item => `answer-${quiz.id}-${question.id}-${item.id}`)) || [],
      })

      question.answers.forEach(answer => {
        answers.push({
          ...answer,
          id: `answer-${quiz.id}-${question.id}-${answer.id}`,
          questionId: `question-${quiz.id}-${question.id}`,
          quizId: `quiz-${quiz.id}`,
          prefix: answer.id,
        })
      })
    })
  })

  const quizesNormalized = normalize(quizes, 'quiz')
  const questionsNormalized = normalize(questions)

  const progress = quizesNormalized.allIds.reduce((acc, item) => {
    const quiz = quizesNormalized.byId[item]
    const total = quiz.questions.length
    const totalPoints = () => {
      let points = 0
      quiz.questions.forEach(i => points+= questionsNormalized.byId[i].points)
      return points
    }

    acc[item] = {
      location: 'intro',
      question: null,
      currentScore: 0,
      totalPoints: totalPoints(),
      totalQuestions: total,
      remainingToView: total,
      remainingToTouch: total,
      remainingToSubmit: total,
    }

    return acc
  }, {})

  return {
    quizes: quizesNormalized,
    questions: questionsNormalized,
    answers: normalize(answers),
    progress,
  }
}

export const normalizeChapters = data => {
  const chapters = []
  const lessons = []
  const aspects = []
  const defaultOptions = {}

  data.chapters.map(chapter => {
    const navItem = data.navigation.find(item => item.chapterId === chapter.id)

    chapters.push({
      ...chapter,
      prefix: navItem ? navItem.id : 0,
      quizId: chapter.quizId ? `quiz-${chapter.quizId}` : null,
      lessons: (chapter.lessons && chapter.lessons.map(item => `lesson-${chapter.id}-${item.id}`)) || [],
    })

    return chapter.lessons.map(lesson => {
      lessons.push({
        ...lesson,
        id: `lesson-${chapter.id}-${lesson.id}`,
        chapterId: `chapter-${chapter.id}`,
        chapterSlug: chapter.slug,
        prefix: lesson.id,
        options: Object.assign({}, defaultOptions, lesson.options),
        aspects: (lesson.aspects && lesson.aspects.map(item => `aspect-${chapter.id}-${lesson.id}-${item.id}`)) || [],
      })

      if(!lesson.aspects) return null

      return lesson.aspects.map(aspect => {
        aspects.push({
          ...aspect,
          id: `aspect-${chapter.id}-${lesson.id}-${aspect.id}`,
          prefix: aspect.id,
          chapterSlug: chapter.slug,
          lessonSlug: lesson.slug,
          options: Object.assign({}, defaultOptions, aspect.options),
        })

        return null
      })
    })
  })

  return {
    chapters: normalize(chapters, 'chapter'),
    lessons: normalize(lessons),
    aspects: normalize(aspects),
    progress: {},
  }
}

export const normalizePages = data => {
  return {
    list: normalize(data, 'page'),
    progress: {},
  }
}

export const normalize = (list, entity) => {
  const getId = id => entity ? `${entity}-${id}` : id

  const listById = list.reduce((acc, item) => {
    acc[getId(item.id)] = {
      ...item,
      id: getId(item.id),
    }

    return acc
  }, {})

  const listAllIds = list.reduce((acc, item) => acc.concat(getId(item.id)), [])

  return {
    byId: listById,
    allIds: listAllIds,
  }
}
